import { useEffect } from 'react';

const pageTitle = (title) => `${title} | Mortgage Tax Payment`;

const Page = (props) => {
  useEffect(() => {
    document.title = pageTitle(props.title || '');
  }, [props.title]);
  return (
    <>
      <div
        style={{
          //TODO: move this to stylesheet
          display: 'flex',
          margin: '0 auto',
          justifyContent: 'flex-start',
          flexFlow: 'column nowrap',
          padding: '10px',
        }}
      >
        {props.children}
      </div>
    </>
  );
};

export default Page;
